const PhoneIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.6249 14.174L20.268 15.75C20.814 16.076 21.0959 16.71 20.9709 17.334C20.4599 19.893 17.89 21.533 15.373 20.842C9.43395 19.212 4.79484 14.587 3.15884 8.635C2.46684 6.117 4.10495 3.54498 6.66495 3.03298L6.68179 3.02999C7.30679 2.90499 7.94395 3.18799 8.26895 3.73699L9.83194 6.376C10.3879 7.315 10.1118 8.52398 9.20279 9.12798L7.5419 10.233C8.7139 13.04 10.9538 15.289 13.7528 16.459L14.8678 14.794C15.4768 13.887 16.6869 13.615 17.6249 14.174Z"
        fill="#663497"
      />
    </svg>
  );
};

export default PhoneIcon;
